export enum FormulaTokenType {
    Number = "Number",
    Time = "Time",
    Operator = "Operator",
    DataField = "DataField",
    DataFieldProperty = "DataFieldProperty"
}